import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button, Space, Typography, Avatar } from 'antd';
import {
  HomeOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  LogoutOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import { useSupplierStore } from '../store/supplierStore';
import { supplierApi } from '../api/supplier';

const { Header, Content, Footer } = Layout;
const { Text } = Typography;

const navItems = [
  { key: '/supplier/home', icon: <HomeOutlined />, label: 'Ballina' },
  { key: '/supplier/purchase-orders', icon: <ShoppingCartOutlined />, label: 'Porositë' },
  { key: '/supplier/profile', icon: <UserOutlined />, label: 'Profili' },
];

const SupplierLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { supplier, logout } = useSupplierStore();

  const handleLogout = async () => {
    try {
      await supplierApi.logout();
    } catch {
      /* ignore */
    }
    logout();
    navigate('/supplier/login');
  };

  const selected = navItems.find((i) => location.pathname.startsWith(i.key))?.key ?? '/supplier/home';

  return (
    <Layout style={{ minHeight: '100vh', background: '#f5f6fa' }}>
      <Header
        style={{
          background: '#111827',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 24px',
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <Space>
          <ShopOutlined style={{ fontSize: 22, color: '#fff' }} />
          <span style={{ color: '#fff', fontSize: 18, fontWeight: 700 }}>
            MTS — Portali i Furnitorit
          </span>
        </Space>
        <Space size="middle">
          {supplier && (
            <>
              <Avatar size="small" icon={<ShopOutlined />} style={{ background: '#059669' }} />
              <Text style={{ color: '#fff' }}>{supplier.name}</Text>
              <Button type="text" icon={<LogoutOutlined />} style={{ color: '#fff' }} onClick={handleLogout}>
                Dil
              </Button>
            </>
          )}
        </Space>
      </Header>

      <Menu
        mode="horizontal"
        selectedKeys={[selected]}
        items={navItems}
        onClick={({ key }) => navigate(key)}
        style={{ background: '#fff', marginBottom: 16, justifyContent: 'center' }}
      />

      <Content style={{ padding: '0 24px', maxWidth: 1100, margin: '0 auto', width: '100%' }}>
        <Outlet />
      </Content>

      <Footer style={{ textAlign: 'center', background: 'transparent' }}>
        <Text type="secondary">MTS Transport DOOEL Skopje — Portali i Furnitorit</Text>
      </Footer>
    </Layout>
  );
};

export default SupplierLayout;
